import {deepFreeze, elfHooks} from '@ngneat/elf';
import {isDevMode} from '@angular/core';

export const freezeStoresStatesHook = () => {
  if (isDevMode()) {
    elfHooks.registerPreStateInit((initialState, storeName) => {
      return deepFreeze(initialState);
    });

    elfHooks.registerPreStoreUpdate((currentState, nextState, storeName) => {
      return deepFreeze(nextState);
    });
  }
};
